import { Group } from "three";
import { Vector3, Matrix4 } from "flavr-math";
export class AvatarShoulder {
    constructor() {
        this.shoulderOffset = new Vector3(0, -0.06, 0.12);
        // #region temp-Vectors and temp-Matrices:
        this.tmpShoulderForward = new Vector3(0, 0, 1);
        this.tmpShoulderRight = new Vector3(1, 0, 0);
        this.tmpShoulderUp = new Vector3(0, 1, 0);
        this.tmpShoulderRotationMatrix = new Matrix4();
        this.tmpShoulderOffset = new Vector3();
        // #endregion
        this.group = new Group();
        this.group.visible = false;
        this.group.matrixAutoUpdate = false;
    }
    destroy() { }
    setVisible(visible) {
        this.group.visible = visible;
    }
    // todo: put this in a base-class with AvatarHead? (group is different, though...)
    addMesh(mesh) {
        mesh.receiveShadow = false;
        mesh.castShadow = false;
        this.group.add(mesh);
    }
    updateTransform(worldPosition, worldOrientation, worldScale) {
        // The origin of the shoulder must be different
        // from the origin origin of the head, otherwise
        // the rotation would look odd.
        // So we need to add an artificial offset to the shoulders:
        this.tmpShoulderOffset.copy(this.shoulderOffset);
        this.tmpShoulderOffset.applyQuaternion(worldOrientation);
        this.tmpShoulderOffset.multiply(worldScale);
        this.group.position.copy(worldPosition).add(this.tmpShoulderOffset);
        // Rotation:
        // 1. We reduce the forward-tilt of the forward-vector:
        this.tmpShoulderForward.set(0, 0, 1);
        this.tmpShoulderForward.applyQuaternion(worldOrientation);
        this.tmpShoulderForward.setY(this.tmpShoulderForward.y * 0.5);
        this.tmpShoulderForward.normalize();
        // 2. We reduce the side-leaning-tilt of the right-vector:
        this.tmpShoulderRight.set(1, 0, 0);
        this.tmpShoulderRight.applyQuaternion(worldOrientation);
        this.tmpShoulderRight.setY(this.tmpShoulderRight.y * 0.5);
        this.tmpShoulderRight.normalize();
        // 3. We calculate the new up-vector by using the cross-product:
        this.tmpShoulderUp.copy(this.tmpShoulderForward);
        this.tmpShoulderUp.cross(this.tmpShoulderRight);
        // 4. The new rotation-Matrix is these three vectors combined. Then we set our rotation-Quaternion from that matrix:
        this.tmpShoulderRotationMatrix.makeBasis(this.tmpShoulderRight, this.tmpShoulderUp, this.tmpShoulderForward);
        this.group.setRotationFromMatrix(this.tmpShoulderRotationMatrix);
        // Scale:
        this.group.scale.copy(worldScale);
        // ...and apply the changes:
        this.group.updateMatrix();
    }
}
